import _taggedTemplateLiteralLoose from 'babel-runtime/helpers/taggedTemplateLiteralLoose';
import _regeneratorRuntime from 'babel-runtime/regenerator';

var _templateObject = _taggedTemplateLiteralLoose(['\n  query decryptionKeys {\n    decryptionKeys {\n      id\n      key\n    }\n  }\n'], ['\n  query decryptionKeys {\n    decryptionKeys {\n      id\n      key\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  query signUri($key: String) {\n    signUri(key: $key)\n  }\n'], ['\n  query signUri($key: String) {\n    signUri(key: $key)\n  }\n']);

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(loadResourceFromPuddleSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(loadDecryptionKeysSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(signAuthUriSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(mediaSagas);

import { ResourceManager } from '@rosetta/resource-manager';
import gql from 'graphql-tag';
import { call, put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { getPuddleConfig } from '../configs/configs';
import { DECRYPTION_KEYS_LOADED, LOAD_DECRYPTION_KEYS, LOAD_RESOURCE_FROM_PUDDLE, mediaActions, mediaSelectors, SIGN_URI } from './media-reducer';

function getResource(keys, root, resourceId) {
  var resourceManager = new ResourceManager(keys, root, '', false);
  return resourceManager.loadResource(resourceId);
}

function loadResourceFromPuddleSaga(action) {
  var decryptionKeys, asset, uri;
  return _regeneratorRuntime.wrap(function loadResourceFromPuddleSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(mediaSelectors.getDecryptionKeys);

        case 2:
          decryptionKeys = _context.sent;

          if (decryptionKeys) {
            _context.next = 9;
            break;
          }

          _context.next = 6;
          return take(DECRYPTION_KEYS_LOADED);

        case 6:
          _context.next = 8;
          return select(mediaSelectors.getDecryptionKeys);

        case 8:
          decryptionKeys = _context.sent;

        case 9:
          _context.prev = 9;
          _context.next = 12;
          return call(getResource, decryptionKeys, getPuddleConfig().encryptedPuddleUriRoot, action.payload.resourceId);

        case 12:
          asset = _context.sent;
          uri = URL.createObjectURL(asset);
          _context.next = 16;
          return put(mediaActions.addResourceLoadedFromPuddle(action.payload.resourceId, uri));

        case 16:
          _context.next = 23;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context['catch'](9);
          _context.next = 22;
          return put(mediaActions.handleError(_context.t0));

        case 22:
          return _context.abrupt('return', _context.sent);

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[9, 18]]);
}

var DecryptionKeysQuery = gql(_templateObject);

function loadDecryptionKeysSaga(action) {
  var response;
  return _regeneratorRuntime.wrap(function loadDecryptionKeysSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(action.payload.apolloClient.query, { query: DecryptionKeysQuery });

        case 2:
          response = _context2.sent;

          if (!response.errors) {
            _context2.next = 7;
            break;
          }

          _context2.next = 6;
          return put(mediaActions.handleError(response.errors[0].message));

        case 6:
          return _context2.abrupt('return', _context2.sent);

        case 7:
          _context2.next = 9;
          return put(mediaActions.decryptionKeysLoaded(response.data.decryptionKeys));

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

var SignUri = gql(_templateObject2);

function signAuthUriSaga(action) {
  var key, signedResponse;
  return _regeneratorRuntime.wrap(function signAuthUriSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          key = action.payload.key;
          _context3.next = 3;
          return action.payload.apolloClient.query({
            query: SignUri,
            variables: { key: key }
          });

        case 3:
          signedResponse = _context3.sent;
          _context3.next = 6;
          return put(mediaActions.uriSigned(key, signedResponse.data));

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

export function mediaSagas() {
  return _regeneratorRuntime.wrap(function mediaSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(LOAD_DECRYPTION_KEYS, loadDecryptionKeysSaga);

        case 2:
          _context4.next = 4;
          return takeEvery(LOAD_RESOURCE_FROM_PUDDLE, loadResourceFromPuddleSaga);

        case 4:
          _context4.next = 6;
          return takeEvery(SIGN_URI, signAuthUriSaga);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}